import { Link } from "gatsby-plugin-react-i18next";
import { LinkSectionLink } from "./LinkSectionLink";

type LinkSectionProps = {
  title: string;
  links: LinkSectionLink[];
};
const LinkSection = ({ title, links }: LinkSectionProps) => {
  return (
    <>
      <h6 className="text-white text-uppercase f-16">{title}</h6>
      <ul className="list-unstyled footer-link mt-3 mb-0">
        {links.map((link, key) => (
          <li key={key}>
            {!link.isExternal ? (
              <Link
                to={link.link}
                placeholder={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              >
                {link.title}
              </Link>
            ) : (
              <a href={link.link}>{link.title}</a>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};

export default LinkSection;
